import { CARRINHO_STEP } from "core/features/carrinho/enums";
import { useLocation } from "react-router-dom";

function useCurrentStep() {
  const pathname = useLocation().pathname;

  if (/^\/ingresso\/[^/]+\/confirmacao\/pix$/.test(pathname)) {
    return CARRINHO_STEP.CONFIRMACAO;
  }

  if (/^\/ingresso\/[^/]+\/pagamento$/.test(pathname)) {
    return CARRINHO_STEP.PAGAMENTO;
  }

  if (/^\/ingresso\/[^/]+\/identificacao$/.test(pathname)) {
    return CARRINHO_STEP.IDENTIFICACAO;
  }

  if (/^\/ingresso\/[a-zA-Z-]+$/.test(pathname)) {
    return CARRINHO_STEP.TIPO_INGRESSO;
  }

  if (/^\/ingresso\/\d+$/.test(pathname)) {
    return CARRINHO_STEP.TIPO_INGRESSO;
  }

  return CARRINHO_STEP.DATA;
}

export default useCurrentStep;
